import Container from "../../../components/container";
import vacanvies from "../../../assets/images/vacancies.svg";
import VacancieItem from "./vacancieItem";
import radius from "../../../assets/images/section2_radius.svg";

export default function Section4() {
    const vacancies = [
        {
            title: "Middle PHP Developer",
            description: "We are looking for a talented PHP Developer with a strong background in backend development to help build and maintain high-performance web applications.",
            requirements: [
                "2+ years of experience with PHP (Laravel, Symfony, or similar frameworks).",
                "Strong knowledge of MySQL, PostgreSQL, or other databases.",
                "Experience with RESTful APIs and microservices architecture.",
                "Familiarity with front-end technologies (JavaScript, HTML, CSS) is a plus.",
                "Good understanding of version control (Git) and CI/CD pipelines."
            ]
        },

        {
            title: "Java Team Lead",
            description: "We need an experienced Java Team Lead to guide a team of developers in designing and implementing scalable software solutions.",
            requirements: [
                "5+ years of experience in Java development (Spring, Hibernate, Microservices).",
                "Strong leadership and project management skills.",
                "Experience in cloud services (AWS, Azure, or GCP).",
                "Deep understanding of software architecture, design patterns, and best practices.",
                "Strong communication and mentoring abilities."
            ]
        },
        {
            title: "AI Engineer",
            description: "We’re looking for an AI Engineer to develop intelligent systems that automate processes, enhance decision-making, and analyze data.",
            requirements: [
                "3+ years of experience in AI development.",
                "Proficiency in Python, TensorFlow, PyTorch, or similar frameworks.",
                "Experience with NLP, computer vision, or predictive analytics.",
                "Strong knowledge of data structures, algorithms, and AI model optimization.",
                "Ability to deploy AI models into production environments."
            ]
        },
        {
            title: "System Administrator (Admin)",
            description: "We need a skilled System Administrator to maintain and optimize our IT infrastructure.",
            requirements: [
                "3+ years of experience in system administration.",
                "Strong knowledge of Linux and Windows servers.",
                "Experience with networking, firewalls, and security best practices.",
                "Familiarity with cloud platforms (AWS, Azure, GCP) and virtualization tools.",
                "Experience with scripting (Bash, Python) and automation tools (Ansible, Terraform)."
            ]
        },
        {
            title: "Machine Learning Engineer",
            description: "We are looking for a Machine Learning Engineer to develop and deploy scalable machine learning models.",
            requirements: [
                "3+ years of experience in ML model development and deployment.",
                "Proficiency in Python and ML frameworks (TensorFlow, Scikit-learn, PyTorch).",
                "Experience with data preprocessing, feature engineering, and model optimization.",
                "Knowledge of big data technologies (Spark, Hadoop) is a plus.",
                "Experience with MLOps tools for deployment and monitoring."
            ]
        },
        {
            title: "Android Developer",
            description: "We’re hiring an Android Developer to create high-quality mobile applications.",
            requirements: [
                "3+ years of experience in Android development (Kotlin, Java).",
                "Strong knowledge of Android SDK, Jetpack, and MVVM/MVP architecture.",
                "Experience integrating RESTful APIs and third-party libraries.",
                "Familiarity with Firebase, Google Play Services, and mobile security best practices.",
                "Experience with Agile development and version control (Git)."
            ]
        },



    ]
    return (<div className='flex flex-col w-full'>
        <div className="flex items-center justify-center w-full"
            id="vacancies"
        >
            <div className="bg-[#71AD80] h-[30px] w-full rounded-r-[5px]"></div>
            <h5 className="text-[#8C4E8C] text-[24px] lg:text-[36px] leading-[30px] lg:leading-[40px] uppercase px-[35px] font-bold">Vacancies</h5>
            <div className="bg-[#71AD80] h-[30px] w-full rounded-l-[5px]"></div>
        </div>
        <Container>
            <div className="flex flex-col w-full justify-center items-center mt-[56px] md:mt-[86px] lg:mt-[76px]">
            <div className="flex relative">
                <img src={vacanvies} alt="vacanvies" className="w-[343px] h-[143px] md:w-[630px] md:h-[251px]" />
                <img src={radius} alt="radius" className="w-[630px] h-[70px] absolute bottom-[-22px] md:bottom-[-41px] left-1/2 transform -translate-x-1/2" />
            </div>

                <h3 className="text-[#71AD80] text-[20px] leading-[30px] md:text-[24px] font-bold mb-[11px] z-10">Join Our Team</h3>
                <p className="text-[14px] lg:text-[15px] leading-[25px] text-[#000] font-normal max-w-[570px] text-center">We’re looking for passionate and skilled professionals to join our growing IT company. If you’re driven by innovation, eager to solve complex challenges, and ready to work in a dynamic environment, we’d love to hear from you!</p>
            </div>
            <div className="flex flex-wrap items-start justify-center gap-[35px] sm:gap-[20px] w-full mt-[73px]">
                {vacancies.map((vacancie, index) => (<VacancieItem
                    key={index}
                    title={vacancie.title}
                    description={vacancie.description}
                    requirements={vacancie.requirements}
                />))}
            </div>
            <div className="flex flex-col items-center">
                <div className="w-[303px] md:w-[340px] lg:w-[300px] xl:w-[370px] flex justify-center items-center mt-[41px] md:mt-[20px] lg:mt-[65px] xl:mt-[70px]">
                    <div className="bg-[#8C328C1A] w-[250px] h-[250px] relative rounded-full circle">
                        <div className="flex flex-col justify-center items-center absolute top-[30px] left-1/2 transform -translate-x-1/2 w-[303px] md:w-[340px] lg:w-[300px] xl:w-[370px]">
                            <h5 className="text-[#71AD80] text-[24px] lg:text-[36px] leading-[30px] font-bold">Why Join Us?</h5>
                            <div className="flex flex-col mt-5">
                                <div className="items-center justify-center gap-[14px] flex">
                                    <div className="bg-[#71AD80] w-[5px] h-[5px] rounded-full hidden sm:block"></div>
                                    <span className="text-[15px] lg:text-[16px] text-[#000] leading-[30px] font-normal text-center">Exciting projects with the latest<br className="block sm:hidden" />technologies</span>
                                    <div className="bg-[#71AD80] w-[5px] h-[5px] rounded-full gap-[14px] hidden sm:block"></div>
                                </div>
                                <div className="items-center justify-center gap-[14px] flex">
                                    <div className="bg-[#71AD80] w-[5px] h-[5px] rounded-full hidden sm:block"></div>
                                    <span className="text-[15px] lg:text-[16px] text-[#000] leading-[30px] font-normal text-center w-max">A collaborative and growth-oriented work<br className="block sm:hidden" />environment</span>
                                    <div className="bg-[#71AD80] w-[5px] h-[5px] rounded-full gap-[14px] hidden sm:block"></div>
                                </div>
                                <div className="items-center justify-center gap-[14px] flex">
                                    <div className="bg-[#71AD80] w-[5px] h-[5px] rounded-full hidden sm:block"></div>
                                    <span className="text-[15px] lg:text-[16px] text-[#000] leading-[30px] font-normal text-center w-max">Competitive salary and career<br className="block sm:hidden" />development opportunities</span>
                                    <div className="bg-[#71AD80] w-[5px] h-[5px] rounded-full gap-[14px] hidden sm:block"></div>
                                </div>
                                <div className="items-center justify-center gap-[14px] flex">
                                    <div className="bg-[#71AD80] w-[5px] h-[5px] rounded-full hidden sm:block"></div>
                                    <span className="text-[15px] lg:text-[16px] text-[#000] leading-[30px] font-normal text-center w-max">Flexible work options and great company<br className="block sm:hidden" /> culture</span>
                                    <div className="bg-[#71AD80] w-[5px] h-[5px] rounded-full gap-[14px] hidden sm:block"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span className="text-[#000000] text-[18px] lg:text-[24px] font-bold mb-[60px] md:mb-[75px] lg:mb-[95px] mt-[110px] sm:mt-6 md:mt-5 text-center">Apply now and be part of our innovative journey!</span>
            </div>
        </Container>
    </div>);
}